module.exports = __webpack_public_path__ + "static/media/HelpCenter.cca3341a.svg";